import {
  ae
} from "./chunk.RIMVGMXQ.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r as r2
} from "./chunk.WKUNRGJV.js";
import {
  e,
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-button-switch/jb-button-switch.scss?inline
var jb_button_switch_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

*:focus-visible {
  outline-color: rgb(var(--theme-color-signal-blue, 0 37 255));
  outline-offset: 6px;
  outline-style: var(--focus-outline-style, auto);
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.state::after, .state::before, h2 {
  font-family: var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-bold-weight, 700);
}

jb-richtext, jb-richtext p {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

h2 {
  font-size: var(--theme-typo-p-small-highlight-desktop-fontsize, 1rem);
  line-height: var(--theme-typo-p-small-highlight-desktop-lineheight, 1.625rem);
}

jb-richtext p {
  font-size: var(--theme-typo-p-mini-desktop-fontsize, 0.813rem);
  line-height: var(--theme-typo-p-mini-desktop-lineheight, 1.25rem);
}

/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  --_color-text-label: var(--theme-color-white, 255 255 255);
  --_color-text-state: rgb(var(--theme-color-royal-blue, 20 30 85));
  --_color-text-state-disabled: rgb(var(--theme-color-white, 255 255 255) / var(--theme-opacity-70, 0.7));
  --_background-color-state: rgb(var(--theme-color-white, 255 255 255) / var(--theme-opacity-70, 0.7));
  --_background-color-state-checked: rgb(var(--theme-color-stone, 176 170 126));
  --_background-color-state-disabled: rgb(var(--theme-color-white, 255 255 255) / 0);
  --_background-color-handle: rgb(var(--theme-color-white, 255 255 255));
  --_background-color-handle-disabled: rgb(var(--theme-color-white, 255 255 255) / var(--theme-opacity-40, 0.4));
  --_color-outline: rgb(var(--theme-color-white, 255 255 255) / 0);
  --_color-outline-checked: rgb(var(--theme-color-stone, 176 170 126));
  --_color-outline-disabled: rgb(var(--theme-color-white, 255 255 255) / var(--theme-opacity-70, 0.7));
}

.inverted {
  --_color-text-label: var(--theme-color-royal-blue, 20 30 85);
  --_color-text-state-disabled: rgb(var(--theme-color-royal-blue, 20 30 85) / var(--theme-opacity-70, 0.7));
  --_background-color-state: rgb(var(--theme-color-royal-blue, 20 30 85) / var(--theme-opacity-20, 0.2));
  --_background-color-handle-disabled: rgb(var(--theme-color-royal-blue, 20 30 85) / var(--theme-opacity-20, 0.2));
  --_color-outline-disabled: rgb(var(--theme-color-royal-blue, 20 30 85) / var(--theme-opacity-40, 0.4));
}

label {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  margin-block-end: 10px;
  padding-block-start: 1px;
}

div {
  block-size: 27px;
  border-radius: 18px;
  display: inline-block;
  inline-size: 60px;
  position: relative;
}

input {
  inset-block-start: 0;
  inset-inline-start: 0;
  margin: 0;
  opacity: 0;
  position: absolute;
}
input:checked ~ .state {
  background-color: var(--_background-color-state-checked);
}
input:checked ~ .state::before {
  opacity: 0;
}
input:checked ~ .state::after {
  opacity: 1;
}
input:checked ~ .handle {
  background: rgb(var(--theme-color-white));
  inset-inline-start: 34px;
}
input:disabled ~ .state {
  background-color: var(--_background-color-state-disabled);
  outline-color: var(--_color-outline-disabled);
  outline-style: dashed;
}
input:disabled ~ .state::after, input:disabled ~ .state::before {
  color: var(--_color-text-state-disabled);
}
input:disabled:checked ~ .state {
  outline-color: var(--_color-outline-checked);
}
input:disabled ~ .handle {
  background-color: var(--_background-color-handle-disabled);
  box-shadow: unset;
}

.state {
  background-color: var(--_background-color-state);
  block-size: inherit;
  border-radius: inherit;
  display: block;
  font-size: 0.625rem;
  outline: 1px solid transparent;
  outline-offset: -1px;
  position: relative;
  text-transform: uppercase;
}
.state::before {
  content: attr(data-off);
  font-size: 0.688rem;
  inset-inline-end: 7px;
  line-height: 0.75rem;
  text-transform: uppercase;
}
.state::after {
  content: attr(data-on);
  font-size: 0.688rem;
  inset-inline-start: 7px;
  line-height: 0.75rem;
  opacity: 0;
  text-transform: uppercase;
}
.state::before, .state::after {
  color: var(--_color-text-state);
  inset-block-start: 50%;
  line-height: 1;
  position: absolute;
  transform: translateY(-49%);
  transition: inherit;
}

.handle {
  background-color: var(--_background-color-handle);
  block-size: 25px;
  border-radius: 100%;
  filter: drop-shadow(2px 0 2px rgba(0, 0, 0, 0.2)) drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
  inline-size: 25px;
  inset-block-start: 1px;
  inset-inline-start: 1px;
  position: absolute;
}

.state,
.handle {
  transition: all 0.2s ease-in-out;
}

h2 {
  color: rgb(var(--_color-text-label));
  margin: 0;
}

jb-richtext {
  color: rgb(var(--_color-text-label)/0.7);
}`;

// src/components/jb-button-switch/jb-button-switch.ts
var JbButtonSwitch = class extends Initiable(r2) {
  async firstUpdated() {
    this.setAttributes();
    const event = new CustomEvent("button-switch:initialized", {
      detail: { buttonSwitch: this },
      bubbles: true
    });
    this.dispatchEvent(event);
  }
  setAttributes() {
    if (this.name) {
      this._checkbox.setAttribute("name", this.name);
    }
    if (this.initialState) {
      this._checkbox.setAttribute("checked", "checked");
    }
    if (this.forceState) {
      this._checkbox.setAttribute("disabled", "disabled");
    }
  }
  setState(state) {
    if (state) {
      this._checkbox.setAttribute("checked", "checked");
    } else {
      this._checkbox.removeAttribute("checked");
    }
  }
  _change(e2) {
    if (!this.name) {
      return;
    }
    const { checked } = e2.target;
    const event = new CustomEvent("button-switch:changed", {
      detail: { name: this.name, checked },
      bubbles: true
    });
    this.dispatchEvent(event);
  }
  _handleKeyboardEvent(evt) {
    if (evt.code === "Enter" || evt.code === "Space") {
      evt.preventDefault();
      this._label.click();
    }
  }
  render() {
    return ke`
      <section
        class=${Rt({
      inverted: this.inverted
    })}
      >
        <label
          data-fly-catcher
          tabindex="${this.forceState ? -1 : 0}"
          @keydown=${this._handleKeyboardEvent}
        >
          <h2>${this.label}</h2>
          <div>
            <input
              tabindex="-1"
              type="checkbox"
              @change=${this._change}
              .disabled=${this.forceState}
            />
            <span
              class="state"
              data-on="${this.onText}"
              data-off="${this.offText}"
            ></span>
            <span class="handle"></span>
          </div>
        </label>
        ${this.description ? ke`<jb-richtext size="mini">${ae(this.description)}</jb-richtext>` : D}
      </section>
    `;
  }
};
JbButtonSwitch.styles = r(jb_button_switch_default);
JbButtonSwitch.shadowRootOptions = { ...r2.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n()
], JbButtonSwitch.prototype, "description", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonSwitch.prototype, "forceState", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonSwitch.prototype, "initialState", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonSwitch.prototype, "inverted", 2);
__decorateClass([
  n()
], JbButtonSwitch.prototype, "label", 2);
__decorateClass([
  n()
], JbButtonSwitch.prototype, "name", 2);
__decorateClass([
  n()
], JbButtonSwitch.prototype, "offText", 2);
__decorateClass([
  n()
], JbButtonSwitch.prototype, "onText", 2);
__decorateClass([
  e("input")
], JbButtonSwitch.prototype, "_checkbox", 2);
__decorateClass([
  e("label")
], JbButtonSwitch.prototype, "_label", 2);
JbButtonSwitch = __decorateClass([
  customElement("jb-button-switch")
], JbButtonSwitch);

export {
  JbButtonSwitch
};
